var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as moment from 'moment';
import { NavigationEnd, Router } from '@angular/router';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { Subject } from 'rxjs';
import { UserService } from '../../shared/services/user.service';
import { combineLatest } from 'rxjs/observable/combineLatest';
var StatsComponent = (function () {
    function StatsComponent(userService, router, challengeService) {
        this.userService = userService;
        this.router = router;
        this.challengeService = challengeService;
        // Whether the user is member in a running team challenge and thus the normal leaderboard should not be displayed
        this.isMemberInRunningChallenge = false;
        this.hideCompanyScoreList = false;
        // check if achievments are activated for company
        this.isAchievementsActivated = false;
        // check if achievements limit is activated
        this.isAchievementsLimitActivated = false;
        this.ngUnsubscribe = new Subject();
        // Scroll to top of page upon navigation end to make sure challenge section is displayed
        this.router.events.takeUntil(this.ngUnsubscribe).subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                window.scrollTo(0, 0);
            }
        });
    }
    StatsComponent.prototype.getCompanyData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var companyData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userService.getCompany()];
                    case 1:
                        companyData = _a.sent();
                        this.hideCompanyScoreList = companyData.hideCompanyScoreList;
                        this.isAchievementsActivated = companyData.activateAchievements;
                        this.isAchievementsLimitActivated = companyData.activateAchievementsLimit;
                        return [2 /*return*/];
                }
            });
        });
    };
    StatsComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCompanyData()];
                    case 1:
                        _a.sent();
                        this.userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
                            if (!user) {
                                return;
                            }
                            _this.user = user;
                        });
                        // Only display normal company leaderboard if user does not take part in a team challenge
                        combineLatest(this.challengeService.displayedChallenge, this.challengeService.team, this.challengeService.teamUser)
                            .takeUntil(this.ngUnsubscribe)
                            .subscribe(function (_a) {
                            var challenge = _a[0], team = _a[1], user = _a[2];
                            _this.teamUser = user;
                            if (
                            // If a challenge is currently running and the user is member of a team
                            challenge &&
                                moment(challenge.start).isBefore(moment()) &&
                                moment(challenge.end).isAfter(moment()) &&
                                user &&
                                user.membershipStatus === 'member' &&
                                team &&
                                team.userGroups.members.length >= challenge.minimalTeamMembers) {
                                _this.isMemberInRunningChallenge = true;
                            }
                            else {
                                _this.isMemberInRunningChallenge = false;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * On destroy cancel active subscriptions
     */
    StatsComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return StatsComponent;
}());
export { StatsComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/stats/stats.component.ts.pre-build-optimizer.js